import { ComponentSingleStyleConfig } from '@chakra-ui/react';
import { keyframes } from '@chakra-ui/system';
import type { SystemStyleFunction } from '@chakra-ui/theme-tools';
import { getColor, mode } from '@chakra-ui/theme-tools';

const fade = (startColor: string, endColor: string) =>
  keyframes({
    from: { borderColor: startColor, background: startColor },
    to: { borderColor: endColor, background: endColor }
  });

const baseStyle: SystemStyleFunction = props => {
  const defaultStartColor = mode('silver.base', 'black.lightest')(props);
  const defaultEndColor = mode('silver.light', 'black.lighter')(props);

  const { startColor = defaultStartColor, endColor = defaultEndColor, speed, theme } = props;

  const start = getColor(theme, startColor);
  const end = getColor(theme, endColor);

  return {
    opacity: 1,
    borderRadius: '4px',
    borderColor: start,
    background: end,
    animation: speed !== 0 ? `${speed}s linear infinite alternate ${fade(start, end)}` : 'none'
  };
};

const SkeletonTheme: ComponentSingleStyleConfig = { baseStyle };

export default SkeletonTheme;
